import request from '@/utils/httpRequest'

export default class QueryInfoService {
	// 查询字典数据详细
	getDicts(dictType) {
	  return request({
	    url: '/system/dict/data/dictType/' + dictType,
	    method: 'get',
		class:'mater'
	  })
	}
	// 费控获取字典集
	getDictMap() {
	  return request({
	    url: '/sys/dict/getDictMap',
	    method: 'get',
	  })
	}
	// 查询用户详细
	getUser(userId) {
	  return request({
	    // url: '/system/user/' + parseStrEmpty(userId),
	    url: '/system/user/' + userId,
	    method: 'get',
		class:'mater'
	  })
	}
	// 查询部门详细
	getDept(deptId) {
	  return request({
	    url: '/system/dept/' + deptId,
	    method: 'get',
		class:'mater'
	  })
	}
	// 根据项目id获取项目下子项目、分期、核算对象信息
	getSubProjectInfosById(id) {
	  return request({
	    url: '/base/project/getSubProjectInfosById',
	    method: 'post',
	    data: id,
		class:'mater'
	  })
	}

	// 查询当前用户拥有操作权限的公司
	 listProject(query) {
	  return request({
	    url: '/base/project/list',
	    method: 'get',
	    params: query,
		class:'mater'
	  })
	}
	// 查询仓库
	getStoreinfo(id) {
		return request({
			url: '/mater/storeinfo/' + id,
			method: 'get',
			class:'mater'
		})
	}
	listMyFlowprocess(query) {
		return request({
			url: '/mater/flowprocess/listmy',
			method: 'get',
			params: query,
			class:'mater'
		})
	}
}
